import React from "react"

class SingleCountry extends React.Component{
constructor(props) {
    super(props)
        this.state = {
          value:"Nigeria"
        }
        this.handleState = this.handleState.bind(this);
      }
    
      handleState() {
            this.setState({
                value:this.props.countryname
            })
            document.getElementById("howvote").scrollIntoView(true);
      }

render(){
    let styledates={
        color:"#ffffff",
        padding:"5px 10px",
        display:"inline-block",
        fontSize:18
    };

    let styleout={
    }

        if (this.props.electiontype === "Presidential" || this.props.electiontype === "presidential"){
            styledates.backgroundColor ="#ff9900"
        } else if (this.props.electiontype === "General" || this.props.electiontype === "general"){
            styledates.backgroundColor ="#cc6733"
        }
        else{
            styledates.backgroundColor ="#996666"
        }

    let nowdate=new Date();
    let dd=nowdate.getDate();
    let mm=nowdate.getMonth() + 1;
    let yyyy = nowdate.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
      }
      
      if (mm < 10) {
        mm = '0' + mm;
      }
    let todaysdate = yyyy+"-"+mm+"-"+dd
    let stylestrike={
        color:"#766c62",
        margin:"1px",
        marginLeft:"5px"
    }


    if (todaysdate > this.props.nextelectiondate){
        styleout.opacity=0.2

    }
    let expandnote = this.props.countryname
    let trimdate = this.props.nextelectiondate
    if (trimdate !== undefined && trimdate.length < 10){
        stylestrike.color="#e8e7e5"
        trimdate = trimdate.slice(-2);
        if (this.props.countryname ==="India"){
            expandnote = this.props.countryname+"**"

        }
        else{
            expandnote = this.props.countryname+"*"
        }
    }
    else if (trimdate !== undefined){
        trimdate = trimdate.slice(-2);
    }

    return(
        <div className="eachentry" style={styleout}>
            <h3 onClick={this.handleState} style={stylestrike}>{trimdate} <span style={styledates}> {expandnote}</span></h3>
        </div>

    )
}
}
export default SingleCountry